module.exports = __webpack_public_path__ + "static/logo-xbox-c0dd6841993f93ac733d295a7ba745d3.png";